// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".option-item .option-item__button{color:#212529}.option-item .option-item__button svg{margin-left:3px;font-size:0.8rem;margin-top:1px}.option-item .option-item__button:hover,.option-item .option-item__button:active,.option-item .option-item__button:focus{text-decoration:none}.option-item .option-item__delete-button{padding:0.375rem 0.3rem;color:#dc3545;font-size:18px}.option-item .option-item__delete-button:hover{color:#c82333}\n", ""]);
// Exports
module.exports = exports;
